export default {
  LEVEL: "level",
  GROWTH: "growth",
  POLICY: "policy",
};
